import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RoomService } from '../services/roomService';
import { RoomData } from '../types/room.types';

export const useRoom = (slug: string | undefined) => {
    const { i18n } = useTranslation();

    const [room, setRoom] = useState<RoomData | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!slug) return;

        const fetchRoom = async () => {
            setLoading(true);
            setError(null);
            try {
                // Detectamos idioma 'es-MX' -> 'es'
                const currentLang = i18n.language.split('-')[0];
                const data = await RoomService.getBySlug(slug, currentLang);
                setRoom(data);
            } catch (err) {
                console.error(err);
                setError('No se pudo cargar la habitación');
            } finally {
                setLoading(false);
            }
        };

        fetchRoom();
    }, [slug, i18n.language]); // Se ejecuta al cambiar slug o idioma

    return { room, loading, error };
};